import { useMemo } from 'react';
import useAuthenticatedUser from './useAuthenticatedUser';
import { KemuProductFeatureValue } from '@kemu-io/kemu-types';

export type BaseSubscriptionInfo = {
  tierName: string;
  lookupKey: string;
  isCustomTier: boolean;
  features: Partial<Record<KemuProductFeatureValue, number>>;
};


const useSubscriptionInfo = (): BaseSubscriptionInfo | null => {
  const user = useAuthenticatedUser();
  const subscriptionItems = user.organization?.stripeSubscription.items;
  const tierItem = subscriptionItems?.find((item) => item.isTier || item.isCustomTier);
  const isCustomTier = tierItem?.isCustomTier || false;

  // Loop through all the items and calculate the total values for each features
  const features = useMemo(() => {
    const aggregatedFeatures: Partial<Record<KemuProductFeatureValue, number>> = {};
    subscriptionItems?.forEach((item) => {
      Object.keys(item.features).forEach((feature) => {
        const featureValue = item.features[feature as KemuProductFeatureValue];
        const prevFeatureValue = aggregatedFeatures[feature as KemuProductFeatureValue] || 0;
        aggregatedFeatures[feature as KemuProductFeatureValue] = featureValue === -1 ? -1 
        : (featureValue || 0) * (item.quantity || 1) + prevFeatureValue;
      });
    });

    return aggregatedFeatures;
  }, [subscriptionItems]);

  if(!tierItem) {
    return null;
  }


  return {
    tierName: tierItem.productName,
    lookupKey: tierItem.lookupKey,
    isCustomTier,
    features,
  };
};

export default useSubscriptionInfo;